export const linkAdapter = (data) => {
  if (!data) return;

  return {
    url: data.url,
    target: data.target,
    title: data.title,
  };
};
